declare global {
  interface Window {
    BXLiveChat: any;
    BX: any;
  }
}

export class BitrixService {
  private static instance: BitrixService;
  private static chatId: string;
  private static userHash: string;
  private static readonly scriptUrl = 'https://cdn.bitrix24.com/b30288443/crm/site_button/loader_4_kmg4zi.js';

  public static getInstance(): BitrixService {
    if (!BitrixService.instance) {
      BitrixService.instance = new BitrixService();
    }
    return BitrixService.instance;
  }

  init(): Promise<boolean> {
    const { id, d, u } = {
      id: 'liveChat',
      d: document,
      u: this.getScriptUrl(),
    };

    return new Promise((resolve, reject) => {
      if (d.getElementById(id)) {
        resolve(true);
        return;
      }

      const s = d.createElement('script');
      s.setAttribute('id', id);
      s.async = true;
      s.src = u + '?' + Date.now() / 60000;

      s.onload = () => {
        resolve(true);
      };

      s.onerror = () => {
        reject(new Error(`Could not load script with id: ${id}`));
      };

      const h = d.getElementsByTagName('script')[0];
      if (h.parentNode) {
        h.parentNode.insertBefore(s, h);
      }
    });
  }

  openChat() {
    if (window.BXLiveChat) {
      window.BXLiveChat.open();
    } else if (window.BX && window.BX.LiveChat) {
      window.BX.LiveChat.open();
    }
  }

  async initAndOpenChat() {
    await this.init();
    await this.waitForBitrixReady();
    this.openChat();
  }

  isReady() {
    return window.BXLiveChat || (window.BX && window.BX.LiveChat);
  }

  getScriptUrl() {
    return BitrixService.scriptUrl;
  }

  waitForBitrixReady(timeout = 10000, interval = 100): Promise<boolean> {
    return new Promise((resolve, reject) => {
      const start = Date.now();

      const checkReady = () => {
        if (this.isReady()) {
          resolve(true);
        } else if (Date.now() - start >= timeout) {
          reject(new Error('Bitrix chat API not ready within timeout'));
        } else {
          setTimeout(checkReady, interval);
        }
      };

      checkReady();
    });
  }

  sendMessage(msg: string) {
    if (
      window.BXLiveChat != null &&
      window.BXLiveChat.__privateMethods__ != null &&
      window.BXLiveChat.__privateMethods__.ready != null &&
      window.BXLiveChat.__privateMethods__.ready == true
    ) {
      window.BXLiveChat.__privateMethods__.addMessage(msg);
    }
  }

  setCustomData(data: any) {
    try {
      console.log('Setting Custom Data');

      if (this.isReady()) {
        window.BXLiveChat.setCustomData([
          {
            USER: {
              NAME: (data.first_name ?? 'Unknown') + ' ' + (data.last_name ?? 'Unknown'), // Insert First and last name.
            },
          },
          {
            GRID: [
              {
                NAME: 'Player Number',
                VALUE: data.username ?? 'Unknown',
                DISPLAY: 'LINE',
              },
              {
                NAME: 'Phone',
                VALUE: data.phone ?? 'Unknown',
                DISPLAY: 'LINE',
              },
              {
                NAME: 'E-mail',
                VALUE: data.email ?? 'Unknown',
                DISPLAY: 'LINE',
              },
              {
                NAME: 'Website',
                VALUE: location.hostname,
                DISPLAY: 'LINE',
              },
              {
                NAME: 'Page',
                VALUE: '[url=' + location.href + ']' + (document.title || location.href) + '[/url]',
                DISPLAY: 'LINE',
              },
              {
                NAME: 'Is Verified?',
                VALUE: data.cognito_match == 1 ? 'Yes' : 'No',
                DISPLAY: 'LINE',
              },
              {
                NAME: 'Player Category',
                VALUE: data?.player_category?.name ?? 'Unknown',
                DISPLAY: 'LINE',
              },
              {
                NAME: 'SignUp Date',
                VALUE: data?.sign_up_date ?? 'Unknown',
                DISPLAY: 'LINE',
              },
              {
                NAME: 'Deposits enabled?',
                VALUE: data.can_deposit == 1 ? 'Yes' : 'No',
                DISPLAY: 'LINE',
              },
              {
                NAME: 'Withdrawals enabled?',
                VALUE: data.can_withdraw == 1 ? 'Yes' : 'No',
                DISPLAY: 'LINE',
              },
              {
                NAME: 'Can Withdraw?',
                VALUE:
                  data.can_perform_withdrawal != null || data.can_perform_withdrawal != undefined
                    ? data.can_perform_withdrawal == true
                      ? 'Yes'
                      : 'No'
                    : 'Unknown',
                DISPLAY: 'LINE',
              },
              {
                NAME: 'No Withdrawal Reason',
                VALUE: data.can_perform_withdrawal_message ?? 'NA',
                DISPLAY: 'LINE',
              },
              {
                NAME: 'Email Verified?',
                VALUE: data.email_verified_at != null ? 'Yes' : 'No',
                DISPLAY: 'LINE',
              },
              {
                NAME: 'Phone Verified?',
                VALUE: data.phone_verified_at != null ? 'Yes' : 'No',
                DISPLAY: 'LINE',
              },
            ],
          },
        ]);
      } else {
        setTimeout(() => {
          console.log('Retrying Setting Custom Data');
          this.setCustomData(data);
        }, 500);
      }
    } catch (error) {
      console.error('Error Setting Custom Data', error);
    }
  }
}

export const BitrixServiceClient = BitrixService.getInstance();
